module.exports = __webpack_public_path__ + "img/img-06.39f7eacd.jpg";